export default () => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "saveStatus",
    align: "center",
    width: 100,
    title: "导入状态",
    slots: { default: "status" },
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 250,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'thermometerNo',
    title: '温度计编号',
    headerAlign: 'center',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'brandLabelName',
    align: 'center',
    minWidth: 120,
    title: '温度计品牌',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'tempRangeName',
    align: 'center',
    minWidth: 120,
    title: '温度区间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'calibrationValidity',
    align: 'center',
    minWidth: 150,
    title: '校准有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
];
